/* Copyright (c) 2017 Backpack Health LLC */
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { withIntl } from '../../../../utilities/localizedUtil';
import RouteNames from '../../../appAuthorized/RouteNames';
import { selectFileFromSource, checkAndRequestFilePermissions, checkAndRequestVideoCameraPermissions, checkAndRequestPhotoCameraPermissions } from '../../../../utilities/MobileUtil';
import { navigate } from '../../../appAuthorized/redux/NavigationActions';
import FileActions from '../../../appAuthorized/redux/FileActions';
import { actions as systemModalActions } from '../../../redux/ducks/systemModal';
import { PermissionsRequiredModal, requiredPermissionTypes } from '../WarningModal';

interface Props {
  intl: any;
  labelId: string;
  type: string;
  successRoute: string;
  dispatch(a): void;
  onCancel?(): void;
}

const selectFile = (type, successRoute, intl, dispatch, onCancel) => {
  let permissionRequest;

  switch (type) {
    case requiredPermissionTypes.video:
      permissionRequest = checkAndRequestVideoCameraPermissions;
      break;
    case requiredPermissionTypes.image:
      permissionRequest = checkAndRequestPhotoCameraPermissions;
      break;
    default:
      permissionRequest = checkAndRequestFilePermissions;
      break;
  }

  permissionRequest(
    () => {
      selectFileFromSource(
        intl.formatMessage({ id: 'ui-data.fileName.untitled.text' }),
        type,
        () => {
          navigate(RouteNames.fileUploadError());
          dispatch(systemModalActions.dismiss());
        },
        imgBlob => {
          FileActions.rawFileSelected(imgBlob);
          navigate(successRoute);
          SpinnerDialog.hide();
          dispatch(systemModalActions.dismiss());
        },
      );
    },
    () => {},
    () => {
      dispatch(systemModalActions.push(<PermissionsRequiredModal onDismiss={onCancel} permissions={[type]} />));
    },
  );
};

const BasicSelectFileItem: FC<Props> = (props) => {
  const { type, successRoute, intl, labelId, dispatch, onCancel } = props;

  return (
    <div
      className="add-item font-color-profile-accent"
      onClick={() => {
        selectFile(type, successRoute, intl, dispatch, onCancel);
      }}
    >
      <div>
        <FormattedMessage id={labelId}/>
      </div>
    </div>
  );
};

const SelectFileItem = connect()(withRouter(withIntl(BasicSelectFileItem)));

export {
  SelectFileItem,
};
